var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body" },
    [
      _c("span", { staticClass: "text-size-20" }, [
        _vm._v("ACROSS倉庫への納品状況を確認いただくことができます")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flexbox gap-15 flex-content-start",
          staticStyle: { "flex-wrap": "nowrap" },
          attrs: { id: "delivery-status-inquiry" }
        },
        [
          _c("div", { staticClass: "filter" }, [
            _c(
              "form",
              { staticClass: "w-210", attrs: { autocomplete: "off" } },
              [
                _c("span", { staticClass: "control-label label-normal" }, [
                  _vm._v("区分")
                ]),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pd-l-10 pd-t-10" },
                  _vm._l(_vm.deliveryKbnOption, function(item) {
                    return _c(
                      "div",
                      { key: item.value, staticClass: "form-check" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.deliveryKbn,
                              expression: "filter.deliveryKbn"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            name: "deliveryKbn",
                            id: "deliveryKbn-" + item.value
                          },
                          domProps: {
                            value: item.value,
                            checked: Array.isArray(_vm.filter.deliveryKbn)
                              ? _vm._i(_vm.filter.deliveryKbn, item.value) > -1
                              : _vm.filter.deliveryKbn
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filter.deliveryKbn,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = item.value,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.filter,
                                      "deliveryKbn",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.filter,
                                      "deliveryKbn",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.filter, "deliveryKbn", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "deliveryKbn-" + item.value }
                          },
                          [_vm._v(_vm._s(item.label))]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label label-normal" }, [
                    _vm._v("納品管理番号")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.filter.deliveryNo,
                        expression: "filter.deliveryNo",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.filter.deliveryNo },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.filterDelivery($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.filter,
                          "deliveryNo",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label label-normal" }, [
                    _vm._v("ASIN")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.filter.asin,
                        expression: "filter.asin",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.filter.asin },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.filterDelivery($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.filter, "asin", $event.target.value.trim())
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "control-label label-normal" }, [
                      _vm._v("納品予定日")
                    ]),
                    _vm._v(" "),
                    _c("date-picker", {
                      ref: "datepickerStart",
                      attrs: {
                        placeholder: "",
                        format: "YYYY/MM/DD",
                        "input-attr": { id: "delivery-date" },
                        lang: _vm.lang
                      },
                      model: {
                        value: _vm.filter.deliveryDate,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "deliveryDate", $$v)
                        },
                        expression: "filter.deliveryDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label label-normal" }, [
                    _vm._v("SKU")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.filter.sku,
                        expression: "filter.sku",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.filter.sku },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.filterDelivery($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.filter, "sku", $event.target.value.trim())
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label label-normal" }, [
                    _vm._v("商品ラベル")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.filter.goodsLabel,
                        expression: "filter.goodsLabel",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.filter.goodsLabel },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.filterDelivery($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.filter,
                          "goodsLabel",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "control-label label-normal" }, [
                  _vm._v("納品状況")
                ]),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pd-l-10 pd-t-10" },
                  _vm._l(_vm.wareHouseStatusOption, function(item) {
                    return _c("div", { key: item, staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.warehouseStatus,
                            expression: "filter.warehouseStatus"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          name: "warehouseStatus",
                          id: "warehouseStatus-" + item
                        },
                        domProps: {
                          value: item,
                          checked: Array.isArray(_vm.filter.warehouseStatus)
                            ? _vm._i(_vm.filter.warehouseStatus, item) > -1
                            : _vm.filter.warehouseStatus
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.filter.warehouseStatus,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = item,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.filter,
                                    "warehouseStatus",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.filter,
                                    "warehouseStatus",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.filter, "warehouseStatus", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "warehouseStatus-" + item }
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("span", { staticClass: "control-label label-normal" }, [
                  _vm._v("表示")
                ]),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "pd-l-10 pd-t-10" }, [
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.isShowDelete,
                          expression: "filter.isShowDelete"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        name: "warehouseStatus",
                        id: "show-delete-item-ckb"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.filter.isShowDelete)
                          ? _vm._i(_vm.filter.isShowDelete, null) > -1
                          : _vm.filter.isShowDelete
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.filter.isShowDelete,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.filter,
                                  "isShowDelete",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.filter,
                                  "isShowDelete",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.filter, "isShowDelete", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "show-delete-item-ckb" }
                      },
                      [_vm._v("削除明細を表示する")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flexbox gap-10 mr-t-10" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary w-100",
                      attrs: { type: "button" },
                      on: { click: _vm.filterDelivery }
                    },
                    [_vm._v("検索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn w-100",
                      attrs: { type: "button" },
                      on: { click: _vm.clearFilter }
                    },
                    [_vm._v("クリア")]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", {}, [
            _c(
              "div",
              { staticClass: "flexbox justify-between" },
              [
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(_vm.pageData.length) + " 件")
                ]),
                _vm._v(" "),
                _c("pagination", {
                  attrs: {
                    totalPage: _vm.totalPage,
                    currentPage: _vm.currentPage,
                    paginationStorageKey: _vm.paginationStorageKey
                  },
                  on: { updateCurrentPage: _vm.updateCurrentPage }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-outter" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.displayData, function(item, index) {
                  return _vm.displayData.length > 0
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "table-group mr-t-10",
                          class: { deleted: item.isDeleted },
                          attrs: { id: "table-group-" + item.deliveryNo }
                        },
                        [
                          _c(
                            "table",
                            { staticStyle: { "table-layout": "fixed" } },
                            [
                              _c("tbody", [
                                _c("tr", [
                                  _c("td", { staticClass: "text-center" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-expand w-100",
                                        attrs: {
                                          "data-toggle": "collapse",
                                          id: "btn-expand-" + item.deliveryNo,
                                          "data-target": "#" + item.deliveryNo,
                                          disabled:
                                            item.deliveryGoods.length === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.handleExpand(item.deliveryNo)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-plus",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" 開く\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-collapse w-100 hidden",
                                        attrs: {
                                          "data-toggle": "collapse",
                                          id: "btn-collapse-" + item.deliveryNo,
                                          "data-target": "#" + item.deliveryNo
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.handleCollapse(item.deliveryNo)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-minus",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" 閉じる\n                  ")
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-left w-160" }, [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getDeliveryKbnText(
                                            item.deliveryKbn
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-left w-200" }, [
                                    _c("div", [_vm._v(_vm._s(item.deliveryNo))])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-left w-250",
                                      staticStyle: { "word-break": "break-all" }
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(_vm._s(item.deliveryName))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-right w-250" },
                                    [
                                      item.deliveryKbn !== "02"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-size-20 font-bold text-primary"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    item.totalArrivalQuantity
                                                  )
                                                ) +
                                                  " / " +
                                                  _vm._s(
                                                    _vm.formatNumber(
                                                      item.totalQuantity
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-size-20 font-bold text-primary"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        item.totalArrivalQuantity
                                                      )
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-size-14"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          _vm.formatNumber(
                                                            item.totalCancelQuantity
                                                          )
                                                        ) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _vm._v(
                                                "\n                    /\n                    " +
                                                  _vm._s(
                                                    _vm.formatNumber(
                                                      item.totalQuantity
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-size-14 text--underline"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-primary",
                                                      attrs: {
                                                        href:
                                                          item.sellerCentralLink,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: _vm.amazonIcon,
                                                          width: "14",
                                                          height: "14"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                        セラーセントラルで確認する\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-left w-150 pd-l-20" },
                                    [
                                      _c("div", { staticClass: "w-130" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-size-16",
                                            class: _vm.getStatusBoxClass(
                                              item.status
                                            )
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(item.status) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.checkDeliveryStatus(item.status)
                                          ? _c("div", {
                                              staticClass: "delivery-status",
                                              class: _vm.getStatusBoxClass(
                                                item.status
                                              )
                                            })
                                          : _vm._e()
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-left w-110" }, [
                                    _c("div", { staticClass: "w-100" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(item.deliveryDate)
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-left w-150" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w-140" },
                                      [
                                        _c("shipping-info", {
                                          key: "info-bubble-" + item.deliveryNo,
                                          attrs: {
                                            delivery: item,
                                            activeDeliveryNo:
                                              _vm.activeDeliveryNo
                                          },
                                          on: {
                                            deliveryInfoRegister:
                                              _vm.deliveryInfoRegister,
                                            updateActiveDeliveryNo:
                                              _vm.updateActiveDeliveryNo
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-left w-125" }, [
                                    _c("div", { staticClass: "btn-group" }, [
                                      _vm._m(1, true),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "dropdown-menu",
                                          attrs: { role: "menu" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass: "check-maintenance",
                                              class: item.disableEdit
                                                ? "disabled"
                                                : "",
                                              attrs: {
                                                disabled: item.disableEdit
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.editDelivery(item)
                                                }
                                              }
                                            },
                                            [_vm._v("編集する")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass: "check-maintenance",
                                              on: {
                                                click: function($event) {
                                                  _vm.openConfirmCoppyModal(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("複製する")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass: "check-maintenance",
                                              class: item.disableDelete
                                                ? "disabled"
                                                : "",
                                              attrs: {
                                                disabled: item.disableDelete
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.openConfirmDeleteDeliveryModal(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("削除する")]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          item.deliveryGoods.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  staticStyle: {
                                    "background-color": "#fff",
                                    margin: "0 10px 10px 10px"
                                  },
                                  attrs: { id: item.deliveryNo }
                                },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "table-item",
                                        attrs: { colspan: "8" }
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              "table-layout": "fixed"
                                            }
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass:
                                                      "text-center w-95"
                                                  },
                                                  [_vm._v("納品する商品")]
                                                ),
                                                _vm._v(" "),
                                                _c("th", {
                                                  staticStyle: {
                                                    "min-width": "500px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass:
                                                      "text-right w-250 pd-r-5"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "納品数 / 納品予定数"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass: "w-200 pd-l-20"
                                                  },
                                                  [_vm._v("商品ラベル")]
                                                ),
                                                _vm._v(" "),
                                                item.deliveryKbn === "01"
                                                  ? _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "w-200 pd-l-5"
                                                      },
                                                      [_vm._v("商品ラベル貼付")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass:
                                                      "text-right w-120"
                                                  },
                                                  [_vm._v("有効期限")]
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                item.deliveryGoods,
                                                function(product) {
                                                  return _c(
                                                    "tr",
                                                    { key: product.itemId },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center"
                                                        },
                                                        [
                                                          product.productImage
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "box-selected-product-image w-50"
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "selected-product-image img-responsive",
                                                                    attrs: {
                                                                      loading:
                                                                        "lazy",
                                                                      src:
                                                                        product.productImage,
                                                                      alt: ""
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          product.judgmentStatusStr
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "box-delivery-judgment-status",
                                                                  class: _vm.getJudgmentStatusClass(
                                                                    product.judgmentStatusStr
                                                                  )
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      product.judgmentStatusStr
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                product.productName
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _c("b", [
                                                              _vm._v("ASIN：")
                                                            ]),
                                                            _vm._v(
                                                              _vm._s(
                                                                product.asin
                                                              ) + " / "
                                                            ),
                                                            _c("b", [
                                                              _vm._v("SKU：")
                                                            ]),
                                                            _vm._v(
                                                              _vm._s(
                                                                product.sku
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _c("b", [
                                                              _vm._v("商品ID：")
                                                            ]),
                                                            _vm._v(
                                                              _vm._s(
                                                                product.itemId
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right font-bold text-size-18"
                                                        },
                                                        [
                                                          item.deliveryKbn !==
                                                          "02"
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "190px"
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          product.arrivalQuantity
                                                                        )
                                                                      ) +
                                                                        " / " +
                                                                        _vm._s(
                                                                          _vm.formatNumber(
                                                                            product.quantity
                                                                          )
                                                                        )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("br"),
                                                                  _vm._v(" "),
                                                                  product.arrivalDatetime
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "(納品日: " +
                                                                              _vm._s(
                                                                                product.arrivalDatetime
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "240px"
                                                                  }
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm.formatNumber(
                                                                              product.arrivalQuantity
                                                                            )
                                                                          ) +
                                                                          "\n                              "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-size-14"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "(" +
                                                                              _vm._s(
                                                                                _vm.formatNumber(
                                                                                  product.cancelQuantity
                                                                                )
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                            /\n                            " +
                                                                        _vm._s(
                                                                          _vm.formatNumber(
                                                                            product.quantity
                                                                          )
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                    _c("br"),
                                                                    _vm._v(" "),
                                                                    product.arrivalDatetime
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(納品日: " +
                                                                                _vm._s(
                                                                                  product.arrivalDatetime
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "custom-dropdown dropdown"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "text--underline text-primary",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fa fa-info-circle",
                                                                              attrs: {
                                                                                "aria-hidden":
                                                                                  "true"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                              Amazonの出荷状況を確認する\n                            "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "dropdown-menu"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "出荷済：" +
                                                                                  _vm._s(
                                                                                    _vm.formatNumber(
                                                                                      product.shippedQuantity
                                                                                    )
                                                                                  )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "キャンセル：" +
                                                                                  _vm._s(
                                                                                    _vm.formatNumber(
                                                                                      product.cancelQuantity
                                                                                    )
                                                                                  )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "保留中：" +
                                                                                  _vm._s(
                                                                                    _vm.formatNumber(
                                                                                      product.pendingQuantity
                                                                                    )
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass: "pd-l-20"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  product.goodsLabel
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      item.deliveryKbn === "01"
                                                        ? _c(
                                                            "td",
                                                            {
                                                              class:
                                                                product.goodsLabelAttachKbn ===
                                                                "0"
                                                                  ? "text-gray"
                                                                  : ""
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.getGoodsLabelAttachKbnText(
                                                                        product.goodsLabelAttachKbn
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right",
                                                          class: product.expirationDate
                                                            ? ""
                                                            : "text-gray"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                product.expirationDate
                                                                  ? _vm.formatDate(
                                                                      product.expirationDate
                                                                    )
                                                                  : "なし"
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.displayData.length === 0
                  ? _c("div", { staticClass: "no-data" }, [
                      _vm._v("\n            データが見つかりません。\n        ")
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.openModalConfirmDeleteDelivery
        ? _c("modal-confirm-delete", {
            on: {
              confirm: function($event) {
                _vm.handleDelete()
              },
              close: function($event) {
                _vm.closeConfirmDeleteDeliveryModal()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openModalConfirmCoppyDelivery
        ? _c("modal-confirm", {
            attrs: { message: _vm.confirmCoppyMessage },
            on: {
              confirm: function($event) {
                _vm.handleCoppy()
              },
              close: function($event) {
                _vm.closeConfirmCoppyModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-header" }, [
      _c("tr", [
        _c("th", { staticClass: "w-110" }),
        _vm._v(" "),
        _c("th", { staticClass: "text-left w-160" }, [_vm._v("区分")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left w-200" }, [_vm._v("納品管理番号")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left w-250" }, [_vm._v("納品名")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right w-250" }, [
          _vm._v("\n              納品数 / 納品予定数\n              "),
          _c("br"),
          _vm._v("\n              ()内はAmazonでのキャンセル数\n            ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left w-150 pd-l-20" }, [
          _vm._v("納品状況")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left w-110" }, [_vm._v("納品予定日")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left w-150" }, [_vm._v("発送情報登録")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-125" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-primary dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _vm._v("\n                      操作\n                      "),
        _c("span", { staticClass: "caret" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f0fc43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f0fc43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/DeliveryStatusInquiry.vue
// module id = null
// module chunks = 